
import { AuthenticationService } from '@app/member-response-portal/service/authentication.service';
import { Helper } from '@rawlings/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationRequestService } from '@app/member-response-portal/service/notification-request.service';
import { Observable, catchError, throwError } from 'rxjs';
//#endregion Imports

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    //#region Constructor
    constructor(
        private authenticationService: AuthenticationService,
        private notificationRequestService: NotificationRequestService,
    ) { }
    //#endregion Constructor

    // eslint-disable-next-line @typescript-eslint/naming-convention
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const token : string = this.authenticationService.GetToken();

        if(!Helper.IsEmpty(token)){
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            })
        }

        return next.handle(request)
        .pipe(
            catchError((error: HttpErrorResponse) => {
                if(error.status === 401 || error.status === 403){
                    this.authenticationService.UnauthorizedRedirectLogin();
                }
                else{
                    this.notificationRequestService.ShowFailedRequestAndLogout(null);
                }

                return throwError(() => error);
            })
        );
    }
}
